import React from 'react';

import { Button } from 'js/design_system/Button';
import { Menu } from 'js/design_system/Menu';
import { MenuItem } from 'js/design_system/MenuItem';
import { openLoginModal } from 'js/login_modal/LoginModalManager';
import { trackClick } from 'js/utils/trackClick';

type Props = {
  figureId: number;
};

export const FigureMoreActionsMenu = ({ figureId }: Props) => {
  const handleSave = () => {
    trackClick({
      source: 'save-button--aei-figure-card',
      entityId: figureId,
    });
    openLoginModal({
      postLoginRedirectUrl: window.location.href,
      clickTrackingContext: {
        source: 'save-button-login-modal--aei-figure-card',
        entityId: figureId,
      },
      configuredText: {
        buttonsPage: { header: 'Read your PDF for free' },
        emailEntryPage: {
          subheader: 'Sign up or log in to continue.',
        },
        emailLoginPage: { subheader: 'Log in to continue.' },
        emailRegistrationPage: {
          subheader: 'Sign up to continue.',
        },
      },
      registrationParams: {
        user_source: 'attachment_extracted_image',
      },
    });
  };

  const handleCite = () => {
    trackClick({
      source: 'cite-button--aei-figure-card',
      entityId: figureId,
    });
    openLoginModal({
      postLoginRedirectUrl: window.location.href,
      clickTrackingContext: {
        source: 'cite-button-login-modal--aei-figure-card',
        entityId: figureId,
      },
      configuredText: {
        buttonsPage: { header: 'Read your PDF for free' },
        emailEntryPage: {
          subheader: 'Sign up or log in to continue.',
        },
        emailLoginPage: { subheader: 'Log in to continue.' },
        emailRegistrationPage: {
          subheader: 'Sign up to continue.',
        },
      },
      registrationParams: {
        user_source: 'attachment_extracted_image',
      },
    });
  };

  const handleShare = () => {
    trackClick({
      source: 'share-button--aei-figure-card',
      entityId: figureId,
    });
    openLoginModal({
      postLoginRedirectUrl: window.location.href,
      clickTrackingContext: {
        source: 'share-button-login-modal--aei-figure-card',
        entityId: figureId,
      },
      configuredText: {
        buttonsPage: { header: 'Read your PDF for free' },
        emailEntryPage: {
          subheader: 'Sign up or log in to continue.',
        },
        emailLoginPage: { subheader: 'Log in to continue.' },
        emailRegistrationPage: {
          subheader: 'Sign up to continue.',
        },
      },
      registrationParams: {
        user_source: 'attachment_extracted_image',
      },
    });
  };

  return (
    <Menu
      placement={'bottom-end'}
      offset={10}
      render={() => (
        <>
          <MenuItem icon="bookmark" onClick={handleSave}>
            Save
          </MenuItem>
          <MenuItem icon="format_quote" onClick={handleCite}>
            Cite
          </MenuItem>
          <MenuItem icon="share" onClick={handleShare}>
            Share
          </MenuItem>
        </>
      )}
    >
      <Button icon="more_vert" secondary size="sm" aria-label="More actions" />
    </Menu>
  );
};
